<template>
    <div class="container-fluid" v-if="tracker && posicao">

        <header-admin :rastreador="tracker" :posicao="posicao" :veiculo="veiculo"></header-admin>

        <vk-tabs keep-alive>

            <vk-tabs-item title="INICIAL">
                <positions-maps :posicao="posicao"/>
            </vk-tabs-item>

            <vk-tabs-item title="COMANDOS" v-if="rastreador">

                <div class="col-sm-3">
                    <enviar-saidas :enable_output2="false" :id_rastreador="rastreador.id_rastreador"/><br/>
                    <reset :id_rastreador="rastreador.id_rastreador"/><br/>
                    <solicitar-configuracao :id_rastreador="rastreador.id_rastreador"/>
                </div>

                <div class="col-sm-9">
                    <table-comandos :id_rastreador="rastreador.id_rastreador"/>
                </div>

            </vk-tabs-item>

            <vk-tabs-item title="PROBLEMAS" v-if="veiculo">
                <problemas  @reload="loadVeiculo($event)" :veiculo="veiculo"></problemas>
            </vk-tabs-item>

            <vk-tabs-item title="VEÍCULO" v-if="veiculo">
                <dados-do-veiculo-admin :veiculo="veiculo"/>
            </vk-tabs-item>

            <vk-tabs-item title="CLIENTE" v-if="cliente">
                <dados-do-cliente-admin :cliente="cliente"/>
            </vk-tabs-item>

            <vk-tabs-item title="RELATÓRIOS" v-if="veiculo">
                <dados-relatorios-admin :veiculo="veiculo" />
            </vk-tabs-item>

            <vk-tabs-item title="CONFIGURAÇÃO">
                <vk-tabs-vertical keep-alive>

                    <vk-tabs-item title="HODOMETRO">
                        <ajustar-hodometro :id_rastreador="rastreador.id_rastreador"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="IP">
                        <ip :config="{ip: null, porta: null}" :id_rastreador="rastreador.id_rastreador"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="IBUTTON">
                        <vk-tabs>
                            <vk-tabs-item title="CADASTRAR" v-if="rastreador && ! isMobile()">
                                <ibutton-config :id_rastreador="rastreador.id_rastreador"/>
                            </vk-tabs-item>
                            <vk-tabs-item title="LISTAGEM" v-if="rastreador && ! isMobile()">
                                <listagem-ibuttons v-if="veiculo" :id_rastreador="rastreador.id_rastreador"  :id_cliente="veiculo.id_cliente" />
                                <listagem-ibuttons v-else :id_rastreador="rastreador.id_rastreador" />
                            </vk-tabs-item>
                        </vk-tabs>
                        
                    </vk-tabs-item>

                </vk-tabs-vertical>
            </vk-tabs-item>

        </vk-tabs>

    </div>
    <div class="container-fluid" v-else>
        <center>
            <h1>Aguardando dados e primeira transmissão</h1>
        </center>
        <vk-tabs keep-alive>

            <vk-tabs-item title="COMANDOS" v-if="rastreador">

                <div class="col-sm-3">
                    <enviar-saidas :enable_output2="false" :id_rastreador="rastreador.id_rastreador"/><br/>
                    <reset :id_rastreador="rastreador.id_rastreador"/><br/>
                    <solicitar-configuracao :id_rastreador="rastreador.id_rastreador"/>
                </div>

                <div class="col-sm-9">
                    <table-comandos :id_rastreador="rastreador.id_rastreador"/>
                </div>

            </vk-tabs-item>
        </vk-tabs>
    </div>
</template>
<script>
    import SolicitarConfiguracao from '../../components/buttons/SolicitarConfiguracao.vue';
    import HeaderAdmin from './HeaderAdmin';
    import Relatorios from '../../components/veiculo/Relatorios';
    import RelatorioPeriodo from '../relatorios/RelatorioPeriodo';
    import FormDirecaoNoturna from '../forms/FormDirecaoNoturna';
    import EnviarSaidas from '../buttons/EnviarSaidas';
    import RelatorioAlertas from "../relatorios/RelatorioAlertas";
    import Problemas from "../veiculo/Problemas";
    import TableComandos from "../tables/TableComandos";
    import Reset from "../buttons/Reset";
    import FormCliente from '../forms/FormCliente';
    import TableTelefonesClientes from '../tables/TableTelefonesClientes';
    import {veiculosAdminMixins} from './partials/veiculo-admin-mixins';
    import PositionsMaps from './partials/PositionsMaps.vue';
    import DadosDoClienteAdmin from './partials/DadosDoClienteAdmin.vue';
    import DadosDoVeiculoAdmin from './partials/DadosDoVeiculoAdmin.vue';
    import DadosRelatoriosAdmin from './partials/DadosRelatoriosAdmin.vue';
    import AjustarHodometro from './partials/AjustarHodometro.vue';
    import IbuttonConfig from './partials/multiportal/IbuttonConfig.vue';
    import ListagemIbuttons from './partials/multiportal/ListagemIbuttons.vue';
    import Ip from './partials/multiportal/Ip';
    import {isMobile} from '../../utils/is-celular';

    export default {
        name: 'RST',

        components: {
            Ip,
            ListagemIbuttons,
            AjustarHodometro,
            IbuttonConfig,
            DadosRelatoriosAdmin,
            DadosDoVeiculoAdmin,
            DadosDoClienteAdmin,
            PositionsMaps,
            TableTelefonesClientes,
            FormCliente,
            Problemas,
            RelatorioAlertas,
            EnviarSaidas,
            FormDirecaoNoturna, HeaderAdmin, Relatorios, RelatorioPeriodo,
            TableComandos, Reset,
            SolicitarConfiguracao
        },

        data(){
            return {
                config: null,
            }
        },

        mixins: [
            veiculosAdminMixins
        ],

        async beforeMount(){
            //this.config = await Concox.byPK(this.rastreador.id_rastreador);
        },

        methods: {
            isMobile() {
                return isMobile()
            }
        },

    }
</script>
